import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
// import { NotificationInfo, UserInfo } from "../../../context";
import Img from "./../../../../assets/tinyimg/empty.webp";

const MerchantEditProduct = ({
  open,
  close,
  setLoading,
  getProductList,
  selectedData,
  categoryList,
  subCategoryList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [isSRPOff, setIsSRPOff] = useState(selectedData.is_srp_off);
  const [selectedIsVariant, setSelectedIsVariant] = useState(
    parseInt(selectedData.has_variant)
  );
  const [selectedIsPcs, setSelectedIsPcs] = useState(
    parseInt(selectedData.is_per_piece)
  );

  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name:
        selectedData.product_image !== null
          ? selectedData.product_image
          : "default-logo.png",
      status: "done",
      url:
        selectedData.product_image !== null
          ? `${import.meta.env.VITE_API_IMAGE}products/${
              selectedData.product_image
            }`
          : Img,
    },
  ]);

  const handleEditProduct = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append("image", values.file === undefined ? "" : values.file.file);
    formdata.append("has_variant", selectedIsVariant);
    formdata.append(
      "is_per_piece",
      parseInt(selectedIsVariant) === 1 ? 0 : selectedIsPcs
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/edit-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited product successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              product: "",
              description: "",
              category: "",
              price: "",
            });
            setLoadings(false);
            setLoading(false);
            getProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleChange = (info) => {
    // console.log(info);
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    // console.log("fileList", fileList);
    setFileList(fileList);
  };

  return (
    <Drawer
      title="Edit Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="edit-products"
          initialValues={{
            product: selectedData.product,
            description: selectedData.description,
            category: parseInt(selectedData.category),
            sub_category: parseInt(selectedData.sub_category),
            purchase_srp: selectedData.purchase_srp,
            srp: selectedData.srp,

            is_srp_off: parseInt(selectedData.is_srp_off),
            before_srp: selectedData.before_srp,

            is_fast_moving: parseInt(selectedData.is_fast_moving),
            is_best_seller: parseInt(selectedData.is_best_seller),

            allow_discount: parseInt(selectedData.allow_discount),

            has_variant: parseInt(selectedData.has_variant),
            is_per_piece: parseInt(selectedData.is_per_piece),
            gram_consumption: selectedData.gram_consumption,
          }}
          onFinish={handleEditProduct}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="file"
              rules={[
                {
                  required: false,
                  message: "Product image required",
                },
              ]}
            >
              <Upload
                beforeUpload={({ fileList: newFileList }) => {
                  // setFileList(newFileList);
                  return false;
                }}
                fileList={fileList}
                onChange={handleChange}
                multiple={false}
                listType="picture-card"
                maxCount={1}
                // defaultFileList={[]}
                showUploadList={{
                  showRemoveIcon: false,
                }}
                // fileList={fileList}
              >
                {/* <Button icon={<UploadOutlined />}>Click to Upload</Button> */}
                Upload
              </Upload>
            </Form.Item>

            <Form.Item
              name="product"
              label="Product Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input
                placeholder="Set product name"
                size="large"
                // value={selectedData.product}
                // defaultValue={selectedData.product.toString()}
              />
            </Form.Item>

            <Form.Item name="description" label="Product Description">
              <Input
                placeholder="Set product description"
                size="large"
                // value={selectedData.description}
                // defaultValue={selectedData.description.toString()}
              />
            </Form.Item>

            <Form.Item
              name="category"
              label="Category"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select category"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {categoryList.data.length > 0 ? (
                  categoryList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.category}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No category found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            {userData.data.usersmerpermission.find(
              ({ permission }) => permission === "allow-sub-category"
            ) && (
              <Form.Item
                name="sub_category"
                label="Station"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select sub category"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {subCategoryList.data.length > 0 ? (
                    subCategoryList.data.map((data, index) => (
                      <Select.Option value={data.id} key={index}>
                        {data.sub_category}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option value="">
                      No sub category found!
                    </Select.Option>
                  )}
                </Select>
              </Form.Item>
            )}

            {userData.data.usersmerpermission.find(
              ({ permission }) => permission === "allow-product-variant"
            ) ? (
              <>
                <Form.Item
                  // name="has_variant"
                  label="Has Variant"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    size="large"
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e) => setSelectedIsVariant(e)}
                    defaultValue={selectedIsVariant}
                  >
                    <Select.Option value={0}>No</Select.Option>
                    <Select.Option value={1}>Yes</Select.Option>
                  </Select>
                </Form.Item>

                {parseInt(selectedIsVariant) === 0 && (
                  <>
                    {userData.data.usersmerpermission.find(
                      ({ permission }) =>
                        permission === "allow-product-per-kilo"
                    ) && (
                      <>
                        <Form.Item
                          // name="is_per_piece"
                          label="Consumption Unit?"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select"
                            size="large"
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(e) => setSelectedIsPcs(e)}
                            defaultValue={selectedIsPcs}
                          >
                            <Select.Option value={0}>Per Gram(s)</Select.Option>
                            <Select.Option value={1}>
                              Per Piece(s)
                            </Select.Option>
                          </Select>
                        </Form.Item>

                        {parseInt(selectedIsPcs) === 1 && (
                          <>
                            <Form.Item
                              name="purchase_srp"
                              label="Purchase SRP"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                // value={selectedData.price}
                                // defaultValue={selectedData.price.toString()}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                              />
                            </Form.Item>

                            <Form.Item
                              name="srp"
                              label="SRP"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                // value={selectedData.price}
                                // defaultValue={selectedData.price.toString()}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                              />
                            </Form.Item>

                            <Form.Item
                              name="is_srp_off"
                              label="Allow SRP off"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select"
                                size="large"
                                showSearch
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setIsSRPOff(e)}
                              >
                                <Select.Option value={0}>No</Select.Option>
                                <Select.Option value={1}>Yes</Select.Option>
                              </Select>
                            </Form.Item>

                            {parseInt(isSRPOff) === 1 && (
                              <Form.Item
                                name="before_srp"
                                label="Before SRP"
                                rules={[
                                  {
                                    required: true,
                                    message: "Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={1}
                                  max={999999999999}
                                  initialvalues={0}
                                  size="large"
                                  style={{ width: "100%" }}
                                  step="0.01"
                                />
                              </Form.Item>
                            )}
                          </>
                        )}

                        {parseInt(selectedIsPcs) === 0 && (
                          <>
                            <Form.Item
                              name="gram_consumption"
                              label="Gram(s) Consumption"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                // onChange={(e) => console.log("CONSUMPTION: ", e)}
                                step="1"
                              />
                            </Form.Item>

                            <Form.Item
                              name="srp"
                              label="SRP"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                              />
                            </Form.Item>

                            <Form.Item
                              name="is_srp_off"
                              label="Allow SRP off"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select"
                                size="large"
                                showSearch
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setIsSRPOff(e)}
                              >
                                <Select.Option value={0}>No</Select.Option>
                                <Select.Option value={1}>Yes</Select.Option>
                              </Select>
                            </Form.Item>

                            {parseInt(isSRPOff) === 1 && (
                              <Form.Item
                                name="before_srp"
                                label="Before SRP"
                                rules={[
                                  {
                                    required: true,
                                    message: "Required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={1}
                                  max={999999999999}
                                  initialvalues={0}
                                  size="large"
                                  style={{ width: "100%" }}
                                  step="0.01"
                                />
                              </Form.Item>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <Form.Item
                  name="purchase_srp"
                  label="Purchase SRP"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                  />
                </Form.Item>

                <Form.Item
                  name="srp"
                  label="SRP"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                  />
                </Form.Item>

                <Form.Item
                  name="is_srp_off"
                  label="Allow SRP off"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    size="large"
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e) => setIsSRPOff(e)}
                  >
                    <Select.Option value={0}>No</Select.Option>
                    <Select.Option value={1}>Yes</Select.Option>
                  </Select>
                </Form.Item>

                {parseInt(isSRPOff) === 1 && (
                  <Form.Item
                    name="before_srp"
                    label="Before SRP"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <InputNumber
                      min={1}
                      max={999999999999}
                      initialvalues={0}
                      size="large"
                      style={{ width: "100%" }}
                      step="0.01"
                    />
                  </Form.Item>
                )}
              </>
            )}

            <Form.Item
              name="is_fast_moving"
              label="Set as Hot"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="is_best_seller"
              label="Set as Best Seller"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>

            {parseInt(selectedIsVariant) === 0 && (
              <Form.Item
                name="allow_discount"
                label="Allow Discount"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Select.Option value={0}>No</Select.Option>
                  <Select.Option value={1}>Yes</Select.Option>
                </Select>
              </Form.Item>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default MerchantEditProduct;
